'use strict';

class recurringService {
  constructor($http) {
    this.$http = $http;
  }

  list() {
    return this.$http.get('/recurring/');
  }

  get(number) {
    return this.$http.get('/recurring/' + number);
  }

  start(number) {
    return this.$http.put('/recurring/' + number + '/start');
  }

  stop(number) {
    return this.$http.put('/recurring/' + number + '/stop');
  }

  delete(number) {
    return this.$http.delete('/recurring/' + number);
  }

  create(params) {
    return this.$http.post('/recurring/', params);
  }

  save(params) {
    return this.$http.post('/recurring/', params);
  }

  update(number, params) {
    return this.$http.put('/recurring/' + number, params);
  }

  calculateDueDate(option, date) {
    const options = {
      lastThisMonth: moment(date, 'YYYY-MM-DD').endOf('month'),
      firstNextMonth: moment(date, 'YYYY-MM-DD').add(1, 'months').startOf('month'),
      lastNextMonth: moment(date, 'YYYY-MM-DD').add(1, 'months').endOf('month'),
      oneWeek: moment(date, 'YYYY-MM-DD').add(1, 'weeks'),
      twoWeeks: moment(date, 'YYYY-MM-DD').add(2, 'weeks'),
      threeWeeks: moment(date, 'YYYY-MM-DD').add(3, 'weeks'),
      fortyFiveDays: moment(date, 'YYYY-MM-DD').add(45, 'days'),
      oneMonth: moment(date, 'YYYY-MM-DD').add(1, 'months'),
      twoMonths: moment(date, 'YYYY-MM-DD').add(2, 'months'),
      threeMonths: moment(date, 'YYYY-MM-DD').add(3, 'months'),
      halfYear: moment(date, 'YYYY-MM-DD').add(6, 'months'),
      oneYear: moment(date, 'YYYY-MM-DD').add(1, 'years')
    };

    if (option && option in options) {
      return options[option];
    }
  }
}

recurringService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('recurringService', recurringService);
